"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getNestedValuesByPath = void 0;
var getNestedValuesByPath = function (obj, path) {
    var nestedValues = obj;
    for (var _i = 0, path_1 = path; _i < path_1.length; _i++) {
        var p = path_1[_i];
        if (!nestedValues[p]) {
            return null;
        }
        nestedValues = nestedValues[p];
    }
    return nestedValues;
};
exports.getNestedValuesByPath = getNestedValuesByPath;
//# sourceMappingURL=getNestedValuesByPath.js.map